import { baseApi } from "api/BaseApi";

import { QuicksightDashboard, QuicksightEmbedUrl } from "./quicksight.types";

const QUICKSIGHT_BASE_URL = "reports/";

const quicksightApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    quicksightReports: build.query<QuicksightDashboard[], void>({
      query: () => `${QUICKSIGHT_BASE_URL}`,
    }),

    quicksightReport: build.query<QuicksightDashboard, number | string>({
      query: (id) => `${QUICKSIGHT_BASE_URL}${id}`,
      providesTags: (_result, _error, arg) => [{ type: "REPORTS", id: arg }],
    }),

    quicksightEmbedUrl: build.query<string, string>({
      query: (report) => `${QUICKSIGHT_BASE_URL}${report}/embed_url`,
      transformResponse: (response: QuicksightEmbedUrl) => response.embedUrl,
      keepUnusedDataFor: 0,
    }),
  }),

  overrideExisting: false,
});

export const {
  useQuicksightReportsQuery,
  useQuicksightReportQuery,
  useQuicksightEmbedUrlQuery,
} = quicksightApi;
